import * as React from "react";

function Tags(props) {
  return (
    <svg width={21} height={17} fill="none" {...props}>
      <path
        d="M17.166 9.725a.829.829 0 00-.274-.639L8.379.688a.829.829 0 00-.593-.251L.984.003a.897.897 0 00-.707.274.897.897 0 00-.274.707l.434 6.687a.96.96 0 00.273.594l8.536 8.376c.183.182.411.274.64.274a.901.901 0 00.638-.274l6.368-6.276a.829.829 0 00.274-.64zm-7.28 4.976L2.261 7.192l-.365-5.295 5.432.343 7.623 7.485-5.067 4.976zM5.935 3.928c.252.251.412.617.412.959 0 .365-.137.708-.411.959a1.42 1.42 0 01-.982.41c-.365 0-.707-.137-.98-.41a1.41 1.41 0 01-.412-.959c0-.365.137-.708.411-.959a1.42 1.42 0 01.981-.41c.366 0 .73.16.982.41zM21 9.725a.9.9 0 01-.228.571l-6.368 6.253a.792.792 0 01-.57.229.792.792 0 01-.571-.229c-.32-.319-.32-.821 0-1.118l5.797-5.683-7.965-7.828c-.32-.32-.32-.822 0-1.118a.8.8 0 011.141 0l8.536 8.353a.9.9 0 01.228.57z"
        stroke="none"
        fill="currentColor"
      />
    </svg>
  );
}

const TagsIcon = React.memo(Tags);
export default TagsIcon;
